import { Component, DestroyRef, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroupDirective, ReactiveFormsModule } from '@angular/forms';
import { EvaluationFeedback, EvaluationReason } from '@vendasta/meeting-analysis';

import { TranslateModule } from '@ngx-translate/core';
import { TranslationModule } from '../../../i18n/translation-module';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatButton } from '@angular/material/button';
import { MatInput } from '@angular/material/input';
import { MatCheckbox } from '@angular/material/checkbox';

import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'crm-feedback-form-modal',
  templateUrl: 'feedback-form-modal.component.html',
  styleUrls: ['./feedback-form-modal.component.scss'],
  imports: [
    TranslateModule,
    TranslationModule,
    ReactiveFormsModule,
    GalaxyFormFieldModule,
    MatDialogModule,
    MatButton,
    MatInput,
    MatCheckbox,
  ],
})
export class FeedbackFormModalComponent {
  @ViewChild('form') formGroupDirective!: FormGroupDirective;

  constructor(
    public dialogRef: MatDialogRef<FeedbackFormModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: FeedbackFormModalData,
    private destroyRef: DestroyRef,
  ) {}

  ngOnInit() {
    this.formGroup.controls['other'].valueChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((otherChecked) => {
        if (otherChecked) {
          this.formGroup.controls['comment'].enable();
        }
      });
  }

  formGroup = new FormBuilder().group({
    inaccurateSummary: [false],
    inaccurateTakeaways: [false],
    inaccurateActionItems: [false],
    lackOfDetails: [false],
    wrongSpeakers: [false],
    other: [false],
    comment: [''],
  });

  submitFeedback() {
    const feedbackReasons: EvaluationReason[] = [];
    const formValues = this.formGroup.value;

    if (formValues.inaccurateSummary) feedbackReasons.push(EvaluationReason.EVALUATION_REASON_INACCURATE_SUMMARY);
    if (formValues.inaccurateTakeaways) feedbackReasons.push(EvaluationReason.EVALUATION_REASON_INACCURATE_TAKEAWAYS);
    if (formValues.inaccurateActionItems)
      feedbackReasons.push(EvaluationReason.EVALUATION_REASON_INACCURATE_ACTION_ITEMS);
    if (formValues.lackOfDetails) feedbackReasons.push(EvaluationReason.EVALUATION_REASON_LACK_OF_DETAILS);
    if (formValues.wrongSpeakers) feedbackReasons.push(EvaluationReason.EVALUATION_REASON_WRONG_SPEAKERS);
    if (formValues.other) feedbackReasons.push(EvaluationReason.EVALUATION_REASON_OTHER);

    const feedbackData = {
      feedbackReasons: feedbackReasons,
      feedbackType: EvaluationFeedback.EVALUATION_FEEDBACK_NEGATIVE,
      comment: formValues.comment,
    };

    this.dialogRef.close(feedbackData);
  }
}

export interface FeedbackFormModalData {
  processedTranscriptID: string;
}
